const content = (
  <div>
    <p>
      Cette formation vous fournit, vous managers, les compétences essentielles
      pour accompagner efficacement vos collaborateurs. Vous apprendrez à
      définir un plan d'action précis pour développer les compétences de votre
      équipe et à mettre en place les conditions nécessaires à la réussite de ce
      plan.
    </p>
    <h2>Public Concerné</h2>
    <p>
      Cette formation s'adresse aux managers d'équipes et à tous ceux qui
      souhaitent structurer et optimiser leurs pratiques managériales.
    </p>
    <h2>Prérequis</h2>
    <p>Des connaissances en management sont nécessaires. </p>
    <p>À la fin de cette formation, le participant saura :</p>
    <ul>
      <li>
        Cultiver un climat de confiance et utiliser la reconnaissance pour
        motiver son équipe
      </li>
      <li>
        Identifier le potentiel et le niveau de maturité de ses collaborateurs
        afin de déléguer les tâches appropriées
      </li>
      <li>
        Transformer les priorités de développement des compétences en objectifs
        concrets
      </li>
      <li>Clarifier et obtenir l'adhésion de tous aux objectifs définis</li>
      <li>Encourager le partage des compétences au sein de l'équipe</li>
    </ul>
    <p>Dates : Définies selon planning</p>
    <p>
      Durée : 2 jours de 9 h00 à 17h, soit 7 heures effectives de formation par
      jour
    </p>
    <p>
      Durée : A distance, avec ou sans regroupements, en partie à distance et en
      partie en présentiel
    </p>
    <p>
      Organisation : A distance, avec ou sans regroupements, en partie à
      distance et en partie en présentiel
    </p>
    <p>En intra ou inter entreprise</p>
    <p>Taille du groupe : jusqu’à 10 stagiaires</p>
    <p>Lieux</p>
    <p>En intra : Chez le client</p>
    <p>En inter : Des salles de formation sont proposées à Paris</p>
    <h2>Accessibilité</h2>
    <p>
      Pour toute situation de handicap merci de nous contacter pour envisager la
      faisabilité
    </p>
    <h2>Délai et modalités d'accès</h2>
    <p>
      Jusqu'à 48h avant le début de la formation et en fonction des plannings
    </p>
    <h2>Tarifs</h2>
    <p>1.200 Euros hors taxes pour les 2 jours de formation par stagiaire</p>
    <h2>
      1/ Améliorer les Collaborateurs en Affinant ses propres comportements
      Managériaux
    </h2>
    <ul>
      <li>Prêter une oreille attentive à ses collaborateurs</li>
      <li>Établir un climat de confiance encourageant le dialogue ouvert</li>
      <li>Utiliser la reconnaissance pour motiver et inspirer</li>
      <li>
        Fournir des feedbacks constructifs pour encourager le développement
        individuel
      </li>
      <li>Soutenir son équipe avec une posture de leader appropriée</li>
    </ul>
    <h3>Exercices pratiques :</h3>
    <p>
      Jeux de rôles pour créer un climat de confiance et fournir des retours
      individualisés.
    </p>
    <h2>2/ Renforcer les Compétences de Ses Collaborateurs</h2> Évaluer le
    potentiel et le degré de maturité de chaque collaborateur.
    <p>Explorer les différentes phases de l'entretien professionnel.</p>
    <p>
      Utiliser la délégation comme un outil de développement des compétences.
    </p>
    <p>
      Engager activement le collaborateur dans son propre développement
      professionnel.
    </p>
    <p>Gérer efficacement les obstacles rencontrés.</p>
    <h3>Exercices pratiques :</h3>
    <p>
      Mises en situation et jeux de rôles pour maîtriser les différentes étapes
      de l'entretien professionnel et s'exercer à la délégation. Analyse et
      restitution personnalisées.
    </p>
    <h2>3/ Prédire l'Évolution des Compétences au sein d'une Équipe</h2>
    <p>
      Analyser le fonctionnement actuel d'une équipe ou d'un projet avec du
      recul.
    </p>
    <p>Établir des priorités pour le développement des compétences.</p>
    <p>Transformer ces priorités en objectifs concrets.</p>
    <p>Communiquer clairement ces objectifs aux collaborateurs.</p>
    <p>Obtenir l'adhésion de chacun aux objectifs fixés.</p>
    <h3>Exercices pratiques :</h3>
    <p>
      Mises en situation individuelles basées sur des cas réels pour déterminer
      les priorités de développement des compétences au sein de l'équipe.
    </p>
    <h2>4/Élaborer un Plan de Développement pour l'Équipe</h2>
    <p>Favoriser le transfert de compétences entre les membres de l'équipe.</p>
    <p>
      Créer une dynamique d'interdépendance au sein de l'équipe et entre les
      équipes.
    </p>
    <p>Encourager et motiver les collaborateurs.</p>
    <p>Concevoir un plan d'action pour l'équipe.</p>
    <h3>Exercices pratiques :</h3>
    <p>
      Travail en sous-groupes sur les meilleures pratiques. Restitution et
      discussions en groupe.
    </p>
    <p>
      Élaboration individuelle du plan d'action avec des recommandations
      personnalisées.
    </p>
    <h2>Modalités pratiques</h2>
    <h3>Travaux pratiques</h3>
    <p>Mise en situation, auto prospection/diagnostic, et cas pratiques</p>
    <h3>Méthodes pédagogiques</h3>
    <p>
      Pédagogie active basée sur des échanges, une évaluation tout au long de la
      formation et de nombreux exercices de mise en application.
    </p>
    <h2>Modalités d'évaluation</h2>
    <p>
      Tout au long de la session de formation, le formateur suit l'avancement
      pédagogique du participant grâce à divers outils tels que des
      questionnaires à choix multiples, des simulations pratiques et d'autres
      exercices appliqués. De plus, le participant réalise un test de
      positionnement avant et après la formation afin de confirmer les
      compétences développées.
    </p>
  </div>
);

export default content;
